import store from "../store";
import axios from "axios";

class Groups {
	async get(uid) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.get(process.env.VUE_APP_SAAS_BACK + "/groups/" + uid, {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data.group);
				})
				.catch(function (error) {
					resolve(null);
				});
		});
	}

	update(group) {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			var url = process.env.VUE_APP_SAAS_BACK + "/groups";
			axios
				.put(
					url,
					{ group },
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve(response.data.group);
				})
				.catch(function (error) {
					resolve(null);
				});
		});
	}
}

export default new Groups();
